const state = {
	lang: "de",
};

const getters = {
	lang: state => state.lang,
};

const actions = {
	setLang({ commit }, newLang) {
		commit("setLang", newLang);
	},
};

const mutations = {
	setLang: (state, newLang) => (state.lang = newLang),
};

export default {
	state,
	getters,
	actions,
	mutations,
};
